// extracted by mini-css-extract-plugin
export default {"startScreen":"Home_startScreen__NA0AB"};